
<!-- <h2>Reset Your Password</h2>
<form (ngSubmit)="submitForgotPasswordForm()" #forgotPasswordForm="ngForm">
<label for="email">Email Address:</label>
<input type="email" id="email" [(ngModel)]="forgotPasswordEmail" name="email" required>
<button type="submit"  [disabled]="!forgotPasswordForm.valid">Continue</button>
</form> -->

<div class="auth-wrapper">
    <div class="align-items-center grid h-full">
      <div class="col-6 h-full">
        <div class="gc-auth-leftPanel">
         <div class="gc-idnty-container">
          <div class="gc-logo">
              <a href=""><img src="../../assets/images/io-logo-green.svg" alt="io-logo.svg"></a>
            </div>
            <div class="">
              <p class="mt-5 ">{{logoText}}</p>
            </div>
          </div>
          <div class="gc-auth-slider">
            <!-- <app-multi-slider></app-multi-slider> -->
            <img src="../../assets/images/banner.svg" alt="banner.svg">
          </div>
          </div>
      </div>
      <div class="col-6 relative justify-content-center flex align-items-center h-full">
        <div class="gc-auth-form-container">
          <div>
            <span class="back-arrow" (click)="navigateToPreviousPage()">
              <em class="pi pi-arrow-left"></em>
            </span>
          </div>
          <h1>Reset Your Password</h1>
          <p>Enter your registered email address to receive a reset link.</p>
          <form #forgotPasswordForm="ngForm" (ngSubmit)="submitForgotPasswordForm()">

            <div class="p-inputgroup mb-5">
              <input type="email" [(ngModel)]="forgotPasswordEmail" name="email" placeholder="Email address" class="p-inputtext" required />
             </div>

            <button type="submit"  [disabled]="!forgotPasswordForm.valid" class="login-btn">Continue</button>
          </form>
        </div>

        <app-footer></app-footer>
      </div>

  </div>
  </div>
